import React from 'react';

import {
  useSelector,
} from 'react-redux';

import {
  Link,
} from 'react-router-dom';

import {
  getItemsStatus,
  getItemsError,
  selectMainHomes,
} from './homesSlice';

import {
  useLanguage,
} from '../../context/LanguageContext';

import SingleSlide
  from '../../components/contentElements/SingleSlide';

import Blockquote
  from '../../components/contentElements/Blockquote';

import Pillar1Image
  from '../../assets/img/activities/pillar1-markets.jpg';

import Pillar2Image
  from '../../assets/img/activities/pillar2-management.jpg';

import Pillar3Image
  from '../../assets/img/activities/pillar3-training.jpg';

import './HomesList.css';


const HomesList = () => {
  const {
    language,
  } = useLanguage();

  const homes =
    useSelector(selectMainHomes);

  const itemStatus =
    useSelector(getItemsStatus);

  const error =
    useSelector(getItemsError);


  const pillarImages = {
    1: Pillar1Image,
    2: Pillar2Image,
    3: Pillar3Image,
  };


  const getTitle = (home) => {
    if (language === 'fr') {
      return (
        home.title_2026_fr ||
        home.title_2026_en ||
        ''
      );
    }

    return (
      home.title_2026_en ||
      home.title_2026_fr ||
      ''
    );
  };


  const getContent = (home) => {
    if (language === 'fr') {
      return (
        home.content_2026_fr ||
        home.content_2026_en ||
        ''
      );
    }

    return (
      home.content_2026_en ||
      home.content_2026_fr ||
      ''
    );
  };


  const selectedItems =
    homes
      .filter(
        (home) =>
          home.main === true &&
          (
            home.title_2026_en ||
            home.title_2026_fr
          )
      )
      .sort(
        (a, b) =>
          Number(a.pilar_id) -
          Number(b.pilar_id)
      );


  if (itemStatus === 'loading') {
    return (
      <>
        <SingleSlide />

        <div className="home-programme-status">
          {language === 'fr'
            ? 'Chargement...'
            : 'Loading...'}
        </div>
      </>
    );
  }


  if (itemStatus === 'failed') {
    return (
      <>
        <SingleSlide />

        <div
          className="
            home-programme-status
            home-programme-error
          "
        >
          {error ||
            (
              language === 'fr'
                ? "Impossible de charger la page d'accueil."
                : 'Unable to load the homepage.'
            )}
        </div>
      </>
    );
  }


  return (
    <>
      <SingleSlide />

      <Blockquote />

      <main className="home-programmes">
        <header className="home-programmes-intro">
          <span className="home-programmes-eyebrow">
            {language === 'fr'
              ? 'Programme ACE 2026–2030'
              : 'ACE Programme 2026–2030'}
          </span>

          <h1>
            {language === 'fr'
              ? 'Trois piliers pour renforcer les opportunités économiques'
              : 'Three Pillars for Stronger Economic Opportunity'}
          </h1>

          <div className="home-programmes-line" />

          <p>
            {language === 'fr'
              ? "ACE relie le développement des entreprises, les compétences et l'emploi à travers trois piliers stratégiques complémentaires."
              : 'ACE connects enterprise development, skills and employment through three complementary strategic pillars.'}
          </p>
        </header>


        <div className="home-pillar-list">
          {selectedItems.map(
            (home, index) => {
              const pillarId =
                Number(
                  home.pilar_id
                );

              const pillarImage =
                pillarImages[
                  pillarId
                ] ||
                Pillar1Image;

              const imageFirst =
                index % 2 === 0;

              return (
                <article
                  key={
                    `home-pillar-${home.id}`
                  }
                  className={
                    `home-pillar-row ${
                      imageFirst
                        ? 'home-pillar-image-first'
                        : 'home-pillar-text-first'
                    }`
                  }
                >
                  <div className="home-pillar-image">
                    <img
                      src={
                        pillarImage
                      }
                      alt={
                        getTitle(home)
                      }
                    />

                    <span className="home-pillar-number">
                      {String(
                        pillarId
                      ).padStart(
                        2,
                        '0'
                      )}
                    </span>
                  </div>


                  <div className="home-pillar-content">
                    <span className="home-pillar-label">
                      {language === 'fr'
                        ? `Pilier ${pillarId}`
                        : `Pillar ${pillarId}`}
                    </span>

                    <h2>
                      {getTitle(
                        home
                      )}
                    </h2>

                    <div className="home-pillar-line" />

                    <p>
                      {getContent(
                        home
                      )}
                    </p>

                    <div className="home-pillar-actions">
                      <Link
                        to="/homes/main"
                        className="home-pillar-primary-link"
                      >
                        {language === 'fr'
                          ? 'Découvrir le programme'
                          : 'Explore the Programme'}

                        <span
                          aria-hidden="true"
                        >
                          →
                        </span>
                      </Link>

                      <Link
                        to={
                          `/results-framework/pillar/${pillarId}`
                        }
                        className="home-pillar-secondary-link"
                      >
                        {language === 'fr'
                          ? 'Cadre de résultats'
                          : 'Results Framework'}
                      </Link>
                    </div>
                  </div>
                </article>
              );
            }
          )}
        </div>
      </main>
    </>
  );
};


export default HomesList;
